/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Svc_Research_Art_FootInputs */

const en_services_svc_research_art_foot = /** @type {(inputs: Services_Svc_Research_Art_FootInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sources: 4, each one checked`)
};

const lv_services_svc_research_art_foot = /** @type {(inputs: Services_Svc_Research_Art_FootInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avoti: 4, katrs pārbaudīts`)
};

/**
* | output |
* | --- |
* | "Sources: 4, each one checked" |
*
* @param {Services_Svc_Research_Art_FootInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const services_svc_research_art_foot = /** @type {((inputs?: Services_Svc_Research_Art_FootInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Svc_Research_Art_FootInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_services_svc_research_art_foot(inputs)
	return en_services_svc_research_art_foot(inputs)
});